import React from 'react';
//import {CSVDownload} from 'react-csv';



class CollectorDetail extends React.Component{
constructor(props){
  super(props);
  this.state = {
    name:'',
    surname:'',
    data:[],
    ddata:false,
    csvDetails:[],
    colid:'',
  }
}

componentDidMount(){
  fetch('https://schoolportal.appsdesign.co.za/get_collector/' + localStorage.getItem('schoolToken'))
  .then((response) => response.json())
  .then((responseJson) => {

    this.setState({
      data: responseJson,

}, function(){

    });

  })
  .catch((error) =>{
    console.error(error);
  });

  }


onNameChange = (event) =>{

  this.setState({name:event.target.value});
}


onSurnameChange = (event) =>{

  this.setState({surname:event.target.value});
}


onIDchange= (event) =>{

  this.setState({colid:event.target.value});
}

render(){

//const csvData = this.state.csvDetails;


const collectorDetails = this.state.data.map((c,i) =>{
if(c.name === this.state.name && c.surname === this.state.surname){
  return(
    <tr key={i}>
    <td>{c.code}</td>
    <td>{c.surname}</td>
    <td>{c.name}</td>
    <td>{c.gender}</td>
    <td>{c.cell}</td>
   <td>{c.email}</td>


    </tr>
  )
}
else if(c.code === this.state.colid){
  return(
    <tr key={i}>
    <td>{c.code}</td>
    <td>{c.surname}</td>
    <td>{c.name}</td>
    <td>{c.gender}</td>
    <td>{c.cell}</td>
   <td>{c.email}</td>


    </tr>
  )
}
else{
  return null
}
})


return(
  <div className="ma2 pa2 br3 shadow-4" style={{display:'flex', flexDirection:'column', justifyContent:'left', margin:100,backgroundColor:'white'}}>
<h1>Collector Details</h1>
<div>
<label htmlFor="name" style={{marginRight:20}}>
Search By Name & Surname</label>
<input
type="text"
placeholder="Name"
id="name"
className="pa2 ma2"
onKeyUp={this.onNameChange}
/>

<input
type="text"
placeholder="CollectorSurname"
id="surname"
className="pa2 ma2"
onKeyUp={this.onSurnameChange}
/>
<br/>

<label htmlFor="colid">
Search By ID</label>
<input
type="text"
placeholder="Collector ID"
id="colid"
className="pa2 ma2"
onKeyUp={this.onIDchange}
/>
<br/>



  <button  className="br3 pa3 bg-blue br-blue" onClick={this.getDetail}>Get Detail</button>
</div>
  <table style={{ margin:10}}>
   <tbody>
  <tr>
<th>Collector ID</th>
<th>Collector Surname</th>
<th>Collector Name</th>
<th>Collector Gender</th>
<th>Contact Cell</th>
<th>Collector Email</th>
  </tr>
{collectorDetails}
 </tbody>
  </table>


</div>
)

}

}

export default CollectorDetail;



// WEBPACK FOOTER //
// ./src/components/CollectorDetail/CollectorDetail.js